export * from './coming-soon.component';
